import React, { useState } from "react";
import ComponentTabComponent from "./componentTab.component";
import Modal from "../../modal";
import { connect, useSelector } from "react-redux";
import { addComponent } from "../../../redux/slice/productPage.slice";
import WebsiteForm from "../../form/websiteForm";
import InstagramForm from "../../form/instagramForm";
import TiktokForm from "../../form/tiktokForm";
import FacebookForm from "../../form/facebookForm";
import VideoForm from "../../form/videoForm";
import TextForm from "../../form/textForm";
import AuthForm from "../../form/authForm";
import MarketplaceForm from "../../form/marketplaceForm";
import GalleryForm from "../../form/galleryForm";
import { renameComponentTitle } from "modules/product-mgmt/utils/productPage.util";
import { getLang } from "app/feature/constants";
import AdditionalInfoForm from "../../form/additionalInfoForm";
import {AccessRights} from "lib/constants/accessRights";
import SurveyForm from "../../form/surveyForm";
import LuckyDrawForm from "../../form/luckyDrawForm";
import InstantWinForm from "../../form/instantWinForm";
import WebVideoForm from "../../form/webVideoForm";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

function ComponentTabContainer({
  addComponent,
  enableAddMarketplace,
  enableAddAuthentication,
  isEditorMode,
  enableAddWarranty,
  enableAddAdditionalInfo,
  enableAddLoyaltyPoint,
  enableAddSurvey,
  enableAddLuckyDraw,
  enableAddInstantWin,
  enableAddCo2Footprint,
  enableAddAuthorisedClinic,
  enableAddSearchTerm2
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newComponent, setNewComponent] = useState("");
  const lang = useSelector((state) => state.constant.languages);
  const hasAdtInfoViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Qr.ADDITIONAL_INFO_READ));
  const hasWarrantyListViewCmpAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Warranty.LIST_READ)
  );
  const hasAuthorisedClinicViewCmpAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.DkshCustom.INVOICE)
  );

  const companyId = useSelector((state) => state.profile.companyID);

  const handleClickChip = (component) => {
    setNewComponent(component);

    if (
      component === "co2 footprint" ||
      component === "warranty" ||
      component === "loyalty point" ||
      component === "authorised clinic" ||
      component === "search term 2"
    ) {
      addComponent({ type: component, content: null });
    } else {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleAddComponent = (values) => {
    addComponent({ type: newComponent, content: values });
    handleCloseModal();
  };

  function getComponentForm() {
    switch (newComponent) {
      case "website":
        return (
          <WebsiteForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
          />
        );

      case "instagram":
        return (
          <InstagramForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
          />
        );

      case "tiktok":
        return (
          <TiktokForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
          />
        );

      case "facebook":
        return (
          <FacebookForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
          />
        );

      case "video":
        return (
          <VideoForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
          />
        );

      case "text":
        return (
          <TextForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
          />
        );

      case "authentication":
        return (
          <AuthForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
          />
        );

      case "marketplace":
        return (
          <MarketplaceForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
          />
        );

      case "gallery":
        return (
          <GalleryForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
          />
        );
      case "web video":
        return (
          <WebVideoForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
          />
        );

      case "additional information":
        if (hasAdtInfoViewAccessRight) {
          return (
            <AdditionalInfoForm
              type="new"
              handleResult={handleAddComponent}
              handleClose={handleCloseModal}
              open={isModalOpen}
            />
          );
        }
        break;

      case "survey":
        return (
          <SurveyForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
            open={isModalOpen}
          />
        );

      case "lucky draw":
        return (
          <LuckyDrawForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
            open={isModalOpen}
          />
        );

      case "instant win":
        return (
          <InstantWinForm
            type="new"
            handleResult={handleAddComponent}
            handleClose={handleCloseModal}
            open={isModalOpen}
          />
        );

      default:
        break;
    }
  }

  return (
    <>
      <ComponentTabComponent
        handleClick={handleClickChip}
        enableAddMarketplace={enableAddMarketplace}
        enableAddAuthentication={enableAddAuthentication}
        enableAddWarranty={enableAddWarranty}
        enableAddAdditionalInfo={enableAddAdditionalInfo}
        enableAddLoyaltyPoint={enableAddLoyaltyPoint}
        enableAddSurvey={enableAddSurvey}
        enableAddLuckyDraw={enableAddLuckyDraw}
        enableAddInstantWin={enableAddInstantWin}
        enableAddCo2Footprint={enableAddCo2Footprint}
        enableAddAuthorisedClinic={enableAddAuthorisedClinic}
        enableAddSearchTerm2={enableAddSearchTerm2}
        isEditorMode={isEditorMode}
        lang={lang}
        hasAdtInfoViewAccessRight={hasAdtInfoViewAccessRight}
        hasWarrantyListViewCmpAccessRight={hasWarrantyListViewCmpAccessRight}
        hasAuthorisedClinicViewCmpAccessRight={
          hasAuthorisedClinicViewCmpAccessRight
        }
        companyId={companyId}
      />
      <Modal
        isOpen={isModalOpen}
        handleClose={handleCloseModal}
        title={renameComponentTitle(lang, newComponent)}
        helperText={
          newComponent === "gallery"
            ? getLang(lang, "paragraph.IMAGE_IN_CAROUSEL_FORMAT")
            : ""
        }
        maxWidth={newComponent === "additional information" ? "sm" : false}
      >
        {getComponentForm()}
      </Modal>
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  addComponent: (payload) => dispatch(addComponent(payload)),
});

const mapStateToProps = (state) => ({
  enableAddMarketplace:
    !state.productPage.columns.compIds.includes("marketplace"),
  enableAddAuthentication:
    !state.productPage.columns.compIds.includes("authentication"),
  enableAddWarranty: !state.productPage.columns.compIds.includes("warranty"),
  enableAddAdditionalInfo: !state.productPage.columns.compIds.includes(
    "additional information"
  ),
  enableAddLoyaltyPoint:
    !state.productPage.columns.compIds.includes("loyalty point"),
  enableAddSurvey:
    state.productPage.columns.compIds.filter((c) => c.startsWith("survey"))
      ?.length < 5,
  enableAddLuckyDraw:
    state.productPage.columns.compIds.filter((c) => c.startsWith("lucky draw"))
      ?.length < 5,
  enableAddInstantWin:
    state.productPage.columns.compIds.filter((c) => c.startsWith("instant win"))
      ?.length < 5,
  enableAddCo2Footprint:
    !state.productPage.columns.compIds.includes("co2 footprint"),
  enableAddAuthorisedClinic:
    !state.productPage.columns.compIds.includes("authorised clinic"),
  enableAddSearchTerm2:
    !state.productPage.columns.compIds.includes("search term 2"),
  isEditorMode: state.productPage.isEditorMode,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ComponentTabContainer);
